import styled from 'styled-components';

export const Main = styled.div`
  display: flex;
  height: 100vh;
`;

export const SecondColumn = styled.div`
  background-color: #F7F9FB;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  flex: 1;
  min-width: 0;
  position: relative;
  margin-left: 294px;
  padding-top: 80px;
  transition: margin-left 0.3s ease;

  footer{
    margin-top: auto;
  }

  &.menu-close {
    margin-left: 55px;
  }

  &.menu-open {
    margin-left: 294px;
  }

  @media(width <= 1200px){
    width: 100vw;
    max-width: 100vw;
    margin-left: 0;
    padding-top: 80px;
    
    &.menu-close,
    &.menu-open {
      margin-left: 0;
    }
  }
`